// Most Likely To buy box: occasion picker, saying ideas, color swatches and live saying preview.
// Everything here drives the theme's own inputs (the Color dropdown and the Saying field); if this
// script fails to load, the standard theme controls still work.
(() => {
  if (window.MLT) return;

  // Occasion dropdown. "sayings" is the holiday key in assets/mlt-sayings.json; "game" is the game's holiday name;
  // "colors" are suggested shirt colors (empty = not chosen yet, so the swatches just show what's available).
  const OCCASIONS = [
    {
      id: 'thanksgiving',
      name: 'Thanksgiving',
      sayings: 'thanksgiving',
      game: 'Thanksgiving',
      colors: ['Antique Orange', 'Texas Orange', 'Brown Savana', 'Dark Chocolate', 'Old Gold', 'Maroon', 'Military Green', 'Sand'],
    },
    {
      id: 'friendsgiving',
      name: 'Friendsgiving',
      sayings: 'thanksgiving',
      game: 'Thanksgiving',
      colors: ['Antique Orange', 'Old Gold', 'Military Green', 'Brown Savana', 'Maroon', 'Sand', 'Texas Orange'],
    },
    {
      id: 'christmas',
      name: 'Christmas',
      sayings: 'christmas',
      game: 'Christmas',
      colors: ['Cardinal Red', 'Red', 'Garnet', 'Forest Green', 'Kelly', 'Irish Green', 'Heather'],
    },
    {
      id: 'halloween',
      name: 'Halloween',
      sayings: 'halloween',
      game: 'Halloween',
      colors: ['Orange', 'Black', 'Purple', 'Lime', 'Charcoal'],
    },
    { id: 'valentines', name: "Valentine's Day", sayings: 'valentines', game: "Valentine's", colors: [] },
    { id: 'stpatricks', name: "St. Patrick's Day", sayings: 'stpatricks', game: "St. Patrick's", colors: [] },
    { id: 'mardigras', name: 'Mardi Gras', sayings: 'mardigras', game: 'Mardi Gras', colors: [] },
    { id: 'july4', name: '4th of July', sayings: 'july4', game: '4th of July', colors: [] },
  ];

  // Approximate shirt colors for swatches.
  const HEX = {
    'Antique Orange': '#b4532a', Azalea: '#f0a1c2', Berry: '#8c2d5d', Black: '#1b1b1b', 'Brown Savana': '#7c5b45',
    'Cardinal Red': '#8a1e2b', 'Carolina Blue': '#7ba4db', Charcoal: '#4a4a4d', 'Coral Silk': '#f58f84',
    'Dark Chocolate': '#3e2a22', 'Dark Heather': '#4f5156', 'Forest Green': '#24402f', Garnet: '#7a1f2b', Gold: '#f2b32b',
    Heliconia: '#e33b8f', 'Indigo Blue': '#3e5873', 'Irish Green': '#1f9e4f', Lilac: '#a88bc4', Lime: '#9bd15b',
    Maroon: '#5b1e2a', 'Military Green': '#5c5f3c', 'Mint Green': '#a6e3c4', Navy: '#1f2a44', 'Old Gold': '#c49a3a',
    Orange: '#f26b21', Purple: '#4b2c82', Red: '#c8102e', Royal: '#1f4fa3', 'Safety Pink': '#f04e98', Sand: '#d9c7a5',
    Sapphire: '#0077b5', 'Sport Grey': '#a7a8aa', Sunset: '#f07f3c', 'Tennessee Orange': '#f5893a',
    'Texas Orange': '#bf5700', 'Tropical Blue': '#0096c7', 'Turf Green': '#2e7d32', Violet: '#7a6fb3', Apple: '#6cb33f',
    Heather: '#9a9da1', 'Hot Pink': '#e7408c', Pink: '#f4b6c7', 'Granite Heather': '#7d7f84', Kelly: '#138a4a',
    Lavender: '#b9a6d6', Mauvelous: '#d88a9a', Brown: '#5a3b2a', 'Key Lime': '#c9e66f', Raspberry: '#c2185b',
    Turquoise: '#22b5c2',
  };

  const params = new URLSearchParams(window.location.search);
  const state = { occasion: null };
  const findOccasion = (id) => OCCASIONS.find((o) => o.id === id) || null;

  const setOccasion = (id) => {
    state.occasion = findOccasion(id);
    document.dispatchEvent(new CustomEvent('mlt:occasion', { detail: state.occasion }));
  };

  const sayingInput = (sectionId) => document.getElementById(`saying-${sectionId}`);
  const colorSelect = (sectionId) =>
    document.querySelector(`#variant-selects-${sectionId} select[name="options[Color]"]`);
  // The theme labels options that can't be bought with the current size "<Value> - Unavailable".
  const isUnavailable = (option) => option.textContent.trim() !== option.value;

  // ---------- Occasion dropdown ----------
  class MltOccasion extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('select');
      OCCASIONS.forEach((o) => select.add(new Option(o.name, o.id)));
      select.addEventListener('change', () => setOccasion(select.value));
      document.addEventListener('mlt:occasion', (e) => {
        select.value = e.detail ? e.detail.id : '';
      });
      const preset = params.get('occasion');
      setOccasion(findOccasion(preset) ? preset : OCCASIONS[0].id);
    }
  }

  // ---------- Pop-ups (size guide, full sayings list) ----------
  function makeDialog(label, extraClass = '') {
    const dialog = document.createElement('dialog');
    dialog.className = `mlt-modal ${extraClass}`.trim();
    dialog.setAttribute('aria-label', label);
    dialog.innerHTML =
      '<div class="mlt-modal__inner"><button type="button" class="mlt-modal__close" aria-label="Close">&times;</button>' +
      '<div class="mlt-modal__body"></div></div>';
    dialog.querySelector('.mlt-modal__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => dialog.returnFocus?.focus());
    document.body.append(dialog);
    return dialog;
  }

  const SIZE_GUIDE_URL = '/pages/size-guide';
  let sizeGuide = null;

  async function openSizeGuide(trigger) {
    if (!sizeGuide) {
      sizeGuide = makeDialog('Size guide');
      const body = sizeGuide.querySelector('.mlt-modal__body');
      body.classList.add('rte');
      try {
        const html = await (await fetch(SIZE_GUIDE_URL)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const title = doc.querySelector('main h1');
        const content = doc.querySelector('main .rte');
        if (!content) throw new Error('no content');
        if (title) body.append(Object.assign(document.createElement('h2'), { className: 'h2', textContent: title.textContent.trim() }));
        body.append(...content.childNodes);
      } catch (e) {
        sizeGuide.remove();
        sizeGuide = null;
        window.location.href = SIZE_GUIDE_URL;
        return;
      }
    }
    sizeGuide.returnFocus = trigger;
    sizeGuide.showModal();
  }

  // ---------- Game pop-up ("Play to find yours") ----------
  // The game is served from this store at /pages/play (templates/page.game.liquid). Shopify won't let
  // storefront pages load inside a frame, so the pop-up fetches that page and runs it via srcdoc.
  // It stays same-site, so the pop-up can read its result messages and keep its shop buttons inside.
  const GAME_URL = '/pages/play';
  const gameHoliday = () => (state.occasion && state.occasion.game) || '';

  function gameUrl(holiday) {
    const url = new URL(GAME_URL, window.location.origin);
    if (holiday) url.searchParams.set('occasion', holiday);
    // Keep the theme preview when browsing an unpublished theme.
    const theme = window.Shopify && window.Shopify.theme;
    if (theme && theme.role !== 'main') url.searchParams.set('preview_theme_id', theme.id);
    return url.toString();
  }

  let gameHtml = null;
  async function loadGameHtml() {
    if (!gameHtml) {
      const response = await fetch(gameUrl(''));
      if (!response.ok) throw new Error('Game page returned ' + response.status);
      gameHtml = await response.text();
    }
    return gameHtml;
  }

  // ---------- Sayings browser ("Browse sayings") ----------
  // Data: assets/mlt-sayings.json, built from the holiday sayings files. Each holiday has tabs
  // (All Sayings, Bestsellers, categories, Couples) whose membership comes from the tab's own id list.
  let sayingsData = null;
  async function loadSayings(url) {
    if (!sayingsData) {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Sayings returned ' + response.status);
      sayingsData = await response.json();
    }
    return sayingsData;
  }

  // Dark text on light tab colors, white on dark ones.
  const tabTextColor = (hex) => {
    const n = parseInt(hex.slice(1), 16);
    const lum = 0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255);
    return lum > 165 ? '#1b202c' : '#ffffff';
  };

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  class SayingsBrowser {
    constructor(onPick) {
      this.onPick = onPick;
      this.dialog = makeDialog('Browse sayings', 'mlt-modal--browser');
      const body = this.dialog.querySelector('.mlt-modal__body');
      const uid = 'mlt-browser-' + Math.random().toString(36).slice(2, 8);
      body.innerHTML =
        '<div class="mlt-browser">' +
        '<div class="mlt-browser__top">' +
        '<h2 class="mlt-browser__title"></h2>' +
        '<p class="mlt-browser__note" hidden></p>' +
        '<label class="visually-hidden" for="' + uid + '">Search sayings</label>' +
        '<input id="' + uid + '" class="mlt-browser__search" type="search" placeholder="Search sayings" autocomplete="off">' +
        '<div class="mlt-browser__tabs" role="tablist" aria-label="Categories"></div>' +
        '</div>' +
        '<div class="mlt-browser__list" role="tabpanel" tabindex="-1">' +
        '<p class="mlt-browser__prefix"></p>' +
        '<div class="mlt-browser__grid"></div>' +
        '<p class="mlt-browser__empty" hidden></p>' +
        '</div>' +
        '</div>';
      this.title = body.querySelector('.mlt-browser__title');
      this.note = body.querySelector('.mlt-browser__note');
      this.search = body.querySelector('.mlt-browser__search');
      this.tabsEl = body.querySelector('.mlt-browser__tabs');
      this.listEl = body.querySelector('.mlt-browser__list');
      this.prefixEl = body.querySelector('.mlt-browser__prefix');
      this.grid = body.querySelector('.mlt-browser__grid');
      this.empty = body.querySelector('.mlt-browser__empty');

      this.search.addEventListener('input', () => this.renderList());
      // Arrow keys move between category tabs (roving tabindex).
      this.tabsEl.addEventListener('keydown', (event) => {
        const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: 'first', End: 'last' };
        if (!(event.key in keys)) return;
        event.preventDefault();
        const count = this.holiday.tabs.length;
        const step = keys[event.key];
        const next = step === 'first' ? 0 : step === 'last' ? count - 1 : (this.active + step + count) % count;
        this.selectTab(next, true);
      });
    }

    async open(occasion, url, returnFocus) {
      this.dialog.returnFocus = returnFocus;
      this.title.textContent = occasion.name;
      this.tabsEl.replaceChildren();
      this.grid.replaceChildren();
      this.prefixEl.textContent = '';
      this.empty.hidden = false;
      this.empty.textContent = 'Loading sayings…';
      this.search.value = '';
      this.dialog.showModal();
      try {
        const data = await loadSayings(url);
        this.prefix = data.prefix;
        this.holiday = data.holidays[occasion.sayings];
        if (!this.holiday) throw new Error('No sayings for ' + occasion.sayings);
      } catch (e) {
        this.holiday = null;
        this.empty.textContent = 'Sayings could not load. Close this and try again.';
        return;
      }
      const borrowed = this.holiday.name !== occasion.name;
      this.note.hidden = !borrowed;
      this.note.textContent = borrowed ? 'Showing ' + this.holiday.name + ' sayings' : '';
      this.renderTabs();
      this.selectTab(0, false);
      this.search.focus();
    }

    renderTabs() {
      this.tabButtons = this.holiday.tabs.map((tab, index) => {
        const button = el('button', 'mlt-browser__tab', tab.name);
        button.type = 'button';
        button.setAttribute('role', 'tab');
        button.style.setProperty('--tab-bg', tab.color);
        button.style.setProperty('--tab-fg', tabTextColor(tab.color));
        button.addEventListener('click', () => this.selectTab(index, false));
        return button;
      });
      this.tabsEl.replaceChildren(...this.tabButtons);
    }

    selectTab(index, focus) {
      this.active = index;
      this.tabButtons.forEach((button, i) => {
        const selected = i === index;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      if (focus) this.tabButtons[index].focus();
      this.tabButtons[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      this.renderList();
      this.listEl.scrollTop = 0;
    }

    renderList() {
      if (!this.holiday) return;
      const tab = this.holiday.tabs[this.active];
      const query = this.search.value.trim().toLowerCase();
      const matches = (text) => !query || text.toLowerCase().includes(query);
      const singles = tab.all ? this.holiday.order : tab.ids || [];
      const texts = singles.map((id) => this.holiday.sayings[id]).filter(matches);
      const pairs = tab.all || tab.couples ? this.holiday.couples.filter((p) => matches(p.shirt_1) || matches(p.shirt_2)) : [];

      const nodes = texts.map((text) => this.sayingButton(text, text));
      if (pairs.length) {
        if (tab.all && texts.length) nodes.push(el('h3', 'mlt-browser__group', 'Couples'));
        pairs.forEach((pair) => {
          const card = el('div', 'mlt-browser__pair');
          card.setAttribute('role', 'group');
          card.setAttribute('aria-label', 'Couples pair');
          card.append(
            this.sayingButton(pair.shirt_1, pair.shirt_1, 'Shirt 1'),
            this.sayingButton(pair.shirt_2, pair.shirt_2, 'Shirt 2')
          );
          nodes.push(card);
        });
      }
      this.grid.replaceChildren(...nodes);
      this.prefixEl.textContent = nodes.length ? this.prefix + '…' : '';

      const total = singles.length + (tab.all || tab.couples ? this.holiday.couples.length : 0);
      this.empty.hidden = nodes.length > 0;
      this.empty.textContent = total === 0 ? 'No sayings in this category yet.' : 'No sayings match "' + this.search.value.trim() + '".';
    }

    sayingButton(text, value, label) {
      const button = el('button', 'mlt-browser__saying');
      button.type = 'button';
      if (label) button.append(el('span', 'mlt-browser__pair-label', label));
      button.append(el('span', 'mlt-browser__text', text));
      button.addEventListener('click', () => this.onPick(value));
      return button;
    }
  }

  class MltSayingIdeas extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.browseButton = this.querySelector('[data-browse]');
      // The saying field lives in this section, so the shirt preview starts here too.
      this.preview = new LivePreview(this.sectionId);

      this.browseButton.addEventListener('click', () => this.openBrowser());
      this.querySelector('[data-spin]').addEventListener('click', () => this.openGame());

      if (params.get('browse') && this.dataset.primary === 'true') {
        window.addEventListener('load', () => this.openBrowser());
      }

      if (params.get('spin') && this.dataset.primary === 'true') {
        window.addEventListener('load', () => this.openGame());
      }
    }

    // Opens the sayings for the occasion selected in the order form.
    openBrowser() {
      if (!state.occasion) return;
      if (!this.browser) {
        this.browser = new SayingsBrowser((text) => {
          this.browser.dialog.returnFocus = sayingInput(this.sectionId);
          this.browser.dialog.close();
          this.use(text);
        });
      }
      this.browser.open(state.occasion, this.dataset.sayingsUrl, this.browseButton);
    }

    async openGame() {
      if (!this.game) this.buildGame();
      const { dialog, frame } = this.game;
      const holiday = gameHoliday();
      dialog.returnFocus = sayingInput(this.sectionId);
      dialog.showModal();
      // Reload only when the occasion changed, so an open game keeps its state between visits.
      if (frame.dataset.loaded && frame.dataset.holiday === holiday) return;
      frame.dataset.holiday = holiday;
      this.setGameResult('');
      try {
        frame.srcdoc = await loadGameHtml();
        frame.dataset.loaded = 'true';
      } catch (e) {
        // Couldn't load it here: open the game on its own page instead.
        dialog.close();
        window.open(gameUrl(holiday), '_blank', 'noopener');
      }
    }

    buildGame() {
      const dialog = makeDialog('Play Most Likely To', 'mlt-modal--game');
      const body = dialog.querySelector('.mlt-modal__body');
      body.innerHTML =
        '<iframe class="mlt-game__frame" title="Most Likely To game" allow="clipboard-write; web-share"></iframe>' +
        '<div class="mlt-game__bar">' +
        '<p class="mlt-game__result" aria-live="polite"></p>' +
        '<button type="button" class="mlt-game__close">Close</button>' +
        '<button type="button" class="button button--primary mlt-game__use" disabled>Use this saying</button>' +
        '</div>';
      const frame = body.querySelector('iframe');
      const apply = () => {
        if (!this.gameSaying) return;
        this.use(this.gameSaying);
        dialog.close();
      };
      body.querySelector('.mlt-game__use').addEventListener('click', apply);
      body.querySelector('.mlt-game__close').addEventListener('click', () => dialog.close());

      // The game posts { type: 'mlt-result', saying | saying1, ... } every time a spin lands.
      window.addEventListener('message', (event) => {
        if (event.origin !== window.location.origin || event.source !== frame.contentWindow) return;
        const data = event.data;
        if (!data || data.type !== 'mlt-result') return;
        this.setGameResult(String(data.saying || data.saying1 || '').trim());
      });

      // Same-site page: "Wear the Evidence" uses the saying here instead of opening a new store tab,
      // and the game's home "Shop" button just returns to the product.
      frame.addEventListener('load', () => {
        let doc;
        try {
          doc = frame.contentDocument;
        } catch (e) {
          return;
        }
        if (!doc) return;
        // Same as the game's ?occasion= link: skip its picker for the holiday chosen here.
        const holiday = frame.dataset.holiday;
        if (holiday && typeof frame.contentWindow.selectCategory === 'function') {
          frame.contentWindow.selectCategory(holiday);
        }
        doc.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('#shopLink')) {
              event.preventDefault();
              apply();
            } else if (event.target.closest('#shopBtnHome')) {
              event.preventDefault();
              event.stopPropagation();
              dialog.close();
            }
          },
          true
        );
      });

      this.game = {
        dialog,
        frame,
        result: body.querySelector('.mlt-game__result'),
        useButton: body.querySelector('.mlt-game__use'),
      };
    }

    setGameResult(saying) {
      this.gameSaying = saying || '';
      const { result, useButton } = this.game;
      useButton.disabled = !saying;
      result.textContent = saying ? '"' + saying + '"' : 'Spin to find their saying.';
    }

    use(text) {
      const input = sayingInput(this.sectionId);
      if (!input) return;
      input.value = text;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus({ preventScroll: true });
    }
  }

  // ---------- Color swatches ----------
  const VISIBLE = 7;

  class MltSwatches extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.row = this.querySelector('.mlt-swatches__row');
      this.more = this.querySelector('.mlt-swatches__more');
      this.current = this.querySelector('[data-current]');
      this.expanded = false;

      this.more.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.render();
      });
      document.addEventListener('mlt:occasion', () => {
        this.expanded = false;
        this.render();
      });

      // Hide the theme's Color dropdown only once swatches are working.
      this.closest('product-info, .product, section')?.classList.add('mlt-has-swatches');

      const picker = document.getElementById(`variant-selects-${this.sectionId}`);
      if (picker && picker.parentElement) {
        new MutationObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.render());
        }).observe(picker.parentElement, { childList: true, subtree: true });
      }
      this.render();
    }

    // "Size guide" sits beside the Size dropdown (the theme re-renders the picker, so re-add it each time).
    placeSizeGuide() {
      const size = document.querySelector(`#variant-selects-${this.sectionId} select[name="options[Size]"]`);
      const field = size && size.closest('.product-form__input');
      if (!field || field.querySelector('.mlt-size-guide')) return;
      field.classList.add('mlt-size-field');
      const link = document.createElement('a');
      link.className = 'mlt-size-guide';
      link.href = SIZE_GUIDE_URL;
      link.textContent = 'Size guide';
      link.addEventListener('click', (event) => {
        event.preventDefault();
        openSizeGuide(link);
      });
      field.append(link);
    }

    render() {
      this.placeSizeGuide();
      const select = colorSelect(this.sectionId);
      if (!select) return;
      const available = Array.from(select.options).filter((o) => !isUnavailable(o)).map((o) => o.value);
      const picks = state.occasion ? state.occasion.colors.filter((c) => available.includes(c)) : [];
      const rest = available.filter((c) => !picks.includes(c));
      const ordered = [...picks, ...rest];
      const shown = this.expanded ? ordered : ordered.slice(0, VISIBLE);
      // Always keep the selected color visible.
      if (!shown.includes(select.value) && available.includes(select.value)) shown.push(select.value);

      this.current.textContent = select.value;

      this.row.replaceChildren(
        ...shown.map((color) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'mlt-swatch-dot';
          b.style.setProperty('--swatch', HEX[color] || '#ccc');
          b.title = color;
          b.setAttribute('aria-label', color);
          b.setAttribute('aria-pressed', String(select.value === color));
          b.addEventListener('click', () => {
            const s = colorSelect(this.sectionId);
            if (!s || s.value === color) return;
            s.value = color;
            s.dispatchEvent(new Event('change', { bubbles: true }));
          });
          return b;
        })
      );

      const hidden = ordered.length - shown.length;
      this.more.hidden = hidden <= 0 && !this.expanded;
      this.more.textContent = this.expanded ? 'Fewer colors' : '+ All colors';
    }
  }

  // ---------- Live saying preview on the shirt photo ----------
  // Every mockup carries a white "most likely to / Print it your way" design. We find the bold
  // "Print it your way" block, cover it with the shirt color, and write the customer's saying there.
  const analysisCache = new Map();

  function analyse(src) {
    const key = src.split('?')[0];
    if (analysisCache.has(key)) return analysisCache.get(key);
    const job = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const N = 300;
          const c = document.createElement('canvas');
          c.width = N;
          c.height = N;
          const ctx = c.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, N, N);
          const px = (x, y) => ctx.getImageData(x, y, 1, 1).data;
          const lum = (d) => 0.299 * d[0] + 0.587 * d[1] + 0.114 * d[2];

          // Garment bounds: everything that differs from the backdrop color in the corner.
          const all = ctx.getImageData(0, 0, N, N).data;
          const bg = [all[0], all[1], all[2]];
          let gx0 = N, gy0 = N, gx1 = 0, gy1 = 0;
          for (let i = 0; i < all.length; i += 4) {
            if (Math.abs(all[i] - bg[0]) + Math.abs(all[i + 1] - bg[1]) + Math.abs(all[i + 2] - bg[2]) > 36) {
              const q = i / 4, x = q % N, y = Math.floor(q / N);
              if (x < gx0) gx0 = x; if (x > gx1) gx1 = x;
              if (y < gy0) gy0 = y; if (y > gy1) gy1 = y;
            }
          }
          let frame = null;
          if (gx1 > gx0 && gy1 > gy0) {
            const gw = (gx1 - gx0) / N, gh = (gy1 - gy0) / N;
            // Garment fills ~90% of the width, never crops the hem or sleeves.
            const scale = Math.max(1, Math.min(0.9 / gw, 0.94 / gh, 1.6));
            const cx = (gx0 + gx1) / 2 / N, cy = (gy0 + gy1) / 2 / N;
            frame = { scale, tx: -(cx - 0.5) * scale, ty: -(cy - 0.5) * scale };
          }
          const done = (spot) => resolve({ frame, spot });

          // Shirt color: average a patch on the chest below the design.
          const patch = ctx.getImageData(N * 0.44, N * 0.6, N * 0.12, N * 0.06).data;
          let r = 0, g = 0, b = 0, n = 0;
          for (let i = 0; i < patch.length; i += 4) { r += patch[i]; g += patch[i + 1]; b += patch[i + 2]; n++; }
          const shirt = [r / n, g / n, b / n];
          const shirtLum = lum(shirt);

          // Shirt edges on a row below the design, so background never counts as "ink".
          const row = Math.round(N * 0.6);
          const sameAsShirt = (d) => Math.abs(d[0] - shirt[0]) + Math.abs(d[1] - shirt[1]) + Math.abs(d[2] - shirt[2]) < 90;
          let left = Math.round(N / 2), right = left;
          while (left > 0 && sameAsShirt(px(left - 1, row))) left--;
          while (right < N - 1 && sameAsShirt(px(right + 1, row))) right++;

          // Design rows: the script "most likely to" line comes first, the bold block follows.
          const x0 = Math.round(left + N * 0.03), x1 = Math.round(right - N * 0.03);
          const y0 = Math.round(N * 0.27), y1 = Math.round(N * 0.6);
          if (x1 - x0 < N * 0.15) return done(null);
          const w = x1 - x0;
          const region = ctx.getImageData(x0, y0, w, y1 - y0).data;
          const rows = [];
          for (let y = 0; y < y1 - y0; y++) {
            let count = 0, minX = N, maxX = 0;
            for (let x = 0; x < w; x++) {
              const i = (y * w + x) * 4;
              if (lum([region[i], region[i + 1], region[i + 2]]) - shirtLum > 55) {
                count++;
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
              }
            }
            rows.push({ y: y0 + y, count, minX: x0 + minX, maxX: x0 + maxX });
          }
          // Group consecutive inked rows into text lines.
          const lines = [];
          let current = null;
          rows.forEach((r) => {
            if (r.count > 0) {
              if (!current) lines.push((current = { top: r.y, bottom: r.y, minX: r.minX, maxX: r.maxX, hits: 0 }));
              current.bottom = r.y;
              current.minX = Math.min(current.minX, r.minX);
              current.maxX = Math.max(current.maxX, r.maxX);
              current.hits += r.count;
            } else if (current && r.y - current.bottom > 1) {
              current = null;
            }
          });
          const solid = lines.filter((l) => l.bottom - l.top >= 2 && l.hits > 15);
          if (solid.length < 2) return done(null);
          // Drop the script line; the rest is the bold "Print it your way" block.
          const block = solid.slice(1);
          const minX = Math.min(...block.map((l) => l.minX)), maxX = Math.max(...block.map((l) => l.maxX));
          const minY = block[0].top, maxY = block[block.length - 1].bottom;
          const hits = block.reduce((n, l) => n + l.hits, 0);
          if (hits < 60 || shirtLum > 215) return done(null);
          const ink = px(Math.round((minX + maxX) / 2), Math.round((minY + maxY) / 2));
          done({
            left: minX / N, top: minY / N, width: (maxX - minX) / N, height: (maxY - minY) / N,
            shirt: `rgb(${shirt.map(Math.round).join(',')})`,
            ink: lum(ink) - shirtLum > 55 ? `rgb(${ink[0]},${ink[1]},${ink[2]})` : '#ffffff',
          });
        } catch (e) {
          resolve({ frame: null, spot: null });
        }
      };
      img.onerror = () => resolve({ frame: null, spot: null });
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', '300');
      img.src = url.toString();
    });
    analysisCache.set(key, job);
    return job;
  }

  // Size text from the box using container units, so it stays right at any photo size.
  function fit(textEl, text) {
    const n = text.length;
    // More words, more lines, smaller type: there is no length limit.
    const lines = n <= 9 ? 1 : n <= 22 ? 2 : n <= 45 ? 3 : n <= 80 ? 4 : n <= 130 ? 5 : 6;
    const perLine = Math.ceil(n / lines);
    textEl.style.fontSize = `min(${(88 / lines).toFixed(1)}cqh, ${(160 / perLine).toFixed(1)}cqw)`;
  }

  class LivePreview {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.input = sayingInput(sectionId);
      this.gallery =
        document.getElementById(`MediaGallery-${sectionId}`) || document.getElementById(`shopify-section-${sectionId}`);
      if (!this.input || !this.gallery) return;

      this.input.addEventListener('input', () => this.update());
      new MutationObserver((records) => {
        if (records.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && !n.closest?.('.mlt-preview-layer')))) {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }
      }).observe(this.gallery, { childList: true, subtree: true });
      window.addEventListener('resize', () => this.update());
      this.update();
    }

    update() {
      this.gallery.querySelectorAll('.product__media').forEach((media) => {
        const img = media.querySelector(':scope > img, img');
        if (!img) return;
        analyse(img.currentSrc || img.src).then(({ frame, spot }) => {
          if (frame) {
            media.classList.add('mlt-framed');
            media.style.setProperty(
              '--mlt-frame',
              `translate(${(frame.tx * 100).toFixed(2)}%, ${(frame.ty * 100).toFixed(2)}%) scale(${frame.scale.toFixed(3)})`
            );
          }
          let layer = media.querySelector(':scope > .mlt-preview-layer');
          const current = this.input.value.trim();
          if (!spot || !current) {
            if (layer) layer.hidden = true;
            return;
          }
          if (!layer) {
            layer = document.createElement('div');
            layer.className = 'mlt-preview-layer';
            layer.setAttribute('aria-hidden', 'true');
            layer.innerHTML = '<div class="mlt-preview"><span class="mlt-preview__text"></span></div>';
            media.append(layer);
          }
          layer.hidden = false;
          const overlay = layer.firstElementChild;
          Object.assign(overlay.style, {
            left: `${(spot.left - 0.015) * 100}%`,
            top: `${(spot.top - 0.012) * 100}%`,
            width: `${(spot.width + 0.03) * 100}%`,
            height: `${(spot.height + 0.024) * 100}%`,
          });
          overlay.style.setProperty('--shirt', spot.shirt);
          overlay.style.setProperty('--ink', spot.ink);
          const textEl = overlay.firstElementChild;
          textEl.textContent = current;
          fit(textEl, current);
        });
      });
    }
  }

  customElements.define('mlt-occasion', MltOccasion);
  customElements.define('mlt-saying-ideas', MltSayingIdeas);
  customElements.define('mlt-swatches', MltSwatches);

  // Links to the game or the sayings list (e.g. the homepage "Play Most Likely To" button, header links) open the
  // pop-up on this page when it has an order section, instead of going to the product page first.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;
    const action = url.searchParams.get('spin') ? 'openGame' : url.searchParams.get('browse') ? 'openBrowser' : null;
    const box = action && document.querySelector('mlt-saying-ideas');
    if (!box) return;
    event.preventDefault();
    box[action]();
  });

  window.MLT = true;
})();
